// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressFrom_wrapper__Lr4Ur","link":"AddressFrom_link__ypjYt"};